import request from '@/utils/request';
//dtc列表
export function queryEgcReportPage(values) {
  return request('/report/queryEgcReportPage', {
    method: 'POST',
    data: values,
  });
}
